export interface VesselActivityState {
    isActive: boolean;
    isFutureActive?: boolean;
}

export const isVesselEffectivelyActive = (vessel: VesselActivityState): boolean => {
    return vessel.isActive || vessel.isFutureActive === true;
};

export const filterVesselsByActivity = <T extends VesselActivityState>(vessels: T[], includeInactiveVessels: boolean): T[] => {
    return includeInactiveVessels ? vessels : vessels.filter(isVesselEffectivelyActive);
};
